"use strict";
// Copyright (c) 2026 The Bitcoin developers
// Distributed under the MIT software license, see the accompanying
// file COPYING or http://www.opensource.org/licenses/mit-license.php.
Object.defineProperty(exports, "__esModule", { value: true });
exports.toBroadcastConfig = void 0;
/**
 * Build ecash-wallet {@link BroadcastConfig} from agora broadcast params.
 */
const toBroadcastConfig = (params) => {
    const { finalizationTimeoutSecs } = params;
    if (finalizationTimeoutSecs == null) {
        return { retryOnUtxoConflict: true };
    }
    return { finalizationTimeoutSecs, retryOnUtxoConflict: true };
};
exports.toBroadcastConfig = toBroadcastConfig;
//# sourceMappingURL=broadcast.js.map